import { createApi } from "@reduxjs/toolkit/query/react";
import { ApiEndpoints, baseQueryWithAuth } from "../../core";
import { ApiResponse, ITier } from "../../types";

export const tierApi = createApi({
  reducerPath: "tierApi",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Tiers"],

  endpoints: (builder) => ({
    getTiers: builder.query<ITier[], void>({
      query: () => ({
        url: ApiEndpoints.tier,
        method: "GET",
        params: {
          limit: -1,
        },
      }),
      transformResponse: (res: ApiResponse<ITier[]>) => {
        return res?.result ?? res?.results ?? [];
      },
      providesTags: ["Tiers"],
    }),

    getTierById: builder.query<ApiResponse<ITier>, string>({
      query: (id) => ({
        url: `${ApiEndpoints.tier}/${id}`,
        method: "GET",
      }),
      providesTags: (_result, _error, id) => [{ type: "Tiers", id }],
    }),

    createTier: builder.mutation<ApiResponse<ITier>, Partial<ITier>>({
      query: (data) => ({
        url: ApiEndpoints.createTier,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Tiers"],
    }),

    editTier: builder.mutation<
      ApiResponse<ITier>,
      { id: string; data: Partial<ITier> }
    >({
      query: ({ id, data }) => ({
        url: `${ApiEndpoints.editTier}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        "Tiers",
        { type: "Tiers", id },
      ],
    }),

    deleteTier: builder.mutation<ApiResponse<void>, string>({
      query: (id) => ({
        url: `${ApiEndpoints.deleteTier}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Tiers"],
    }),
  }),
});

export const {
  useGetTiersQuery,
  useGetTierByIdQuery,
  useCreateTierMutation,
  useEditTierMutation,
  useDeleteTierMutation,
} = tierApi;
